/* eslint-disable import/no-unresolved */
import React from 'react';
import PropTypes from 'prop-types';

import { SecurityTOTPLayout } from 'assets/components';

import { securityTOTPScreens } from './constants';
import { SecurityTOTPProvider } from '../../contexts/SecurityTOTP/context';
import TOTPMain from './Main';
import SecurityTOTPScan from './Scan';
import SecuritySaveTOTPKey from './Save';
import SecurityVerifyTOTPSecret from './Verify';
import SecurityResetTOTPSecret from './ResetWarning';
import SecurityTOTPResetSecretTFA from './ResetTFA';

const SecurityTOTP = ({ screen }) => (
  <SecurityTOTPProvider>
    <SecurityTOTPLayout currentScreen={screen}>
      <TOTPMain keyName={securityTOTPScreens.MAIN} />
      <SecurityTOTPScan keyName={securityTOTPScreens.SCAN} />
      <SecuritySaveTOTPKey keyName={securityTOTPScreens.SAVE} />
      <SecurityVerifyTOTPSecret keyName={securityTOTPScreens.VERIFY} />
      <SecurityResetTOTPSecret keyName={securityTOTPScreens.RESET_WARNING} />
      <SecurityTOTPResetSecretTFA keyName={securityTOTPScreens.RESET_TFA} />
    </SecurityTOTPLayout>
  </SecurityTOTPProvider>
);
export default SecurityTOTP;

SecurityTOTP.propTypes = {
  screen: PropTypes.string.isRequired,
};
